import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'

InertiaProgress.init({
  delay: 50,
  color: "#FF8506",
  includeCSS: true,
  showSpinner: false,
});

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - Tarmac` : 'Tarmac App',
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
/*      .mixin({
        methods: {
          pickjobsite: (jid) => {
            document.cookie = 'jobsite=' + jid +';path=/;';
            try {
              //document.querySelector('#updatejobsite').click(); 
              window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
            } catch(e) { console.error(e); }
          }
        }
      })
*/
      .mount(el)
  },
})
